import { render, staticRenderFns } from "./ColumnDrag.vue?vue&type=template&id=b467edde&scoped=true"
import script from "./ColumnDrag.vue?vue&type=script&lang=js"
export * from "./ColumnDrag.vue?vue&type=script&lang=js"
import style0 from "./ColumnDrag.vue?vue&type=style&index=0&id=b467edde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b467edde",
  null
  
)

export default component.exports